import Tree from '../components/Tree';
import {
  onLoadChildren as onLoadChildrenCallback,
  TreeNode,
  NodeId,
} from '../types';
import TreeContextProvider from '../context/TreeContextProvider';

export interface TreeViewNavigationProps {
  label: string;
  nodes: TreeNode[];
  onSelect: (nodeId: NodeId) => void;
  currentChapterId?: number;
  onLoadChildren?: onLoadChildrenCallback;
}

export default function TreeViewNavigation({
  label,
  nodes,
  currentChapterId,
  onSelect,
  onLoadChildren,
}: Readonly<TreeViewNavigationProps>) {
  return (
    <TreeContextProvider
      nodes={nodes}
      currentChapterId={currentChapterId}
      onSelect={onSelect}
      onLoadChildren={onLoadChildren}
    >
      <nav aria-label={label}>
        <Tree label={label} />
      </nav>
    </TreeContextProvider>
  );
}
